module.exports = __webpack_public_path__ + "img/img3.0b5a9f6.png";